module.exports = __webpack_public_path__ + "img/logo.eeadabd4.png";